import api from '../config/axiosConfig';

export const MarcasService = {
    getMarcasActivos: async (token) => {
        try {
            const response = await api.get('/marcas/activos', {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data || [];
        } catch (error) {
            console.error('Error en MarcasService.getMarcasActivos:', error);
            throw error;
        }
    },
    getMarcas: async ({ token, pagina = 1, pageSize = 20, descripcion = '' }) => {
        try {
            const response = await api.get('/marcas', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, descripcion },
            });
            return {
                marcas: response.data.marcas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en MarcasService.getMarcas:', error);
            throw error;
        }
    },
    registrarMarca: async ({ token, form, imagen }) => {
        try {
            const data = new FormData();
            data.append('descripcion', form.descripcion);
            data.append('estado', form.estado);
            if (imagen) {
                data.append('imagen', imagen);
            }
            const response = await api.post('/marcas', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcasService.registrarMarca:', error);
            throw error;
        }
    },
    fetchMarcaPorId: async ({ token, id }) => {
        try {
            const response = await api.get(`/marcas/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcasService.fetchMarcaPorId:', error);
            throw error;
        }
    },
    editarMarca: async ({ token, id, form, imagen }) => {
        try {
            const data = new FormData();
            data.append('descripcion', form.descripcion);
            data.append('estado', form.estado);
            if (imagen) {
                data.append('imagen', imagen);
            }
            const response = await api.put(`/marcas/${id}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcasService.editarMarca:', error);
            throw error;
        }
    },
    toggleEstadoMarca: async ({ token, marca }) => {
        try {
            const response = await api.put(`/marcas/${marca.id_marca}/deactivate`, {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en MarcasService.toggleEstadoMarca:', error);
            throw error;
        }
    },
    getMiMarcas: async (token) => {
        try {
            const response = await api.get('/users/mi-marcas', {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data.marcas || [];
        } catch (error) {
            console.error('Error en MarcasService.getMiMarcas:', error);
            throw error;
        }
    },
    getMarcasByUserId: async ({ token, userId }) => {
        try {
            const response = await api.get(`/users/${userId}/marcas`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data.marcas || [];
        } catch (error) {
            console.error('Error en MarcasService.getMarcasByUserId:', error);
            throw error;
        }
    },
};
